import { type ReactNode } from 'react';

export type LibraryDetailsAccessibilityProps = {
  description: string;
  label: string;
  icon: ReactNode;
};

export const LibraryDetailsAccessibility = ({ description, icon, label }: LibraryDetailsAccessibilityProps) => {
  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center gap-1 font-medium ads:text-secondary text-14 text-pigeon-600">
        {icon}
        {label}
      </div>

      <p className="ads:text-secondary text-12 text-pigeon-500">{description}</p>
    </div>
  );
};
